import { InjectionToken } from '@angular/core';

/**
 * Injection token to provide the
 */
export const CONNECTED_PLAYER_SRC = new InjectionToken<string>(
  'bmat.angular.media-players.connected-player-src',
);
